/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { smallerDependencies } from './dependenciesSmaller.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createMinTransform } from '../../factoriesAny.js';
export var minTransformDependencies = {
  smallerDependencies: smallerDependencies,
  typedDependencies: typedDependencies,
  createMinTransform: createMinTransform
};